let requiredNotDirective = function () {
  return function () {
    return {
      restrict: "A",
      require: "ngModel",
      scope: {
        invalidValues: "=requiredNotValues"
      },
      link: function (scope, element, attrs, ngModel) {
        ngModel.$validators.requiredNot = function (modelValue) {
          return scope.invalidValues.indexOf(modelValue) === -1;
        };
      },
    };
  };
};

export default angular.module("directives.requiredNot", [])
  .directive("requiredNot", requiredNotDirective())
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/required-not.directive.js
 **/